export default __webpack_public_path__ + "static/media/logo_Blue_Tulip.ed4fe1a7.png";